import { render } from "./OffersList.vue?vue&type=template&id=a37122a6&scoped=true"
import script from "./OffersList.vue?vue&type=script&lang=js"
export * from "./OffersList.vue?vue&type=script&lang=js"

import "./OffersList.vue?vue&type=style&index=0&id=a37122a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37122a6"]])

export default __exports__